export const RESUME_URL = "https://drive.google.com/file/d/1SerQEm3YzZE_0WdCW6t47N2qdtBiU8BK/view?usp=drive_link"
